<template>
  <div id="ComponentInventoryList">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <template v-if="!showBarcode">
          <div class="page-name">
            <div class="page-title"> {{ pageTitle }}</div>
            <!-- Button for Clear Cache -->
            <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
            <div class="btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                <i class="fp-export"></i> Export
              </a>
            </div>
          </div>
          <div class="container-fluid">
            <div class="admin-page-content component-inventory-list">
              <data-table-filter-config :moduleName="'ComponentInventoryList'" ref="filterComponentInventory"
                                        @cancelSelection="cancelAll"
                                        :allowSameFilter="'allow'"></data-table-filter-config>
              <section class="data-table bg-white">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process.
                  batch no. is {{ batchNum }}.
                  <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank"
                               @click.native="batchProcess = 0"> Click Here
                  </router-link>
                  to check file status!
                </p>
                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange" :moduleName="'ComponentInventoryList'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                  ref="listComponentInventoryTable"
                  mode="remote"
                  title="Part Transaction"
                  @on-page-change="onPageChange"
                  @on-selected-rows-change="selectionChanged"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  @on-sort-change="onSortChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :pagination-options="{
                                            enabled: false,
                                            position: 'both',
                                            perPage: perPage,
                                            perPageDropdown:dropDownPerPage,
                                            dropdownAllowAll: false,
                                        }"
                  :select-options="{
                                        enabled: false,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                        }"
                  :search-options="{
                                        enabled: false,
                                        }">
                  <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                    <div :key="key">
                      <div>
                        {{ props.formattedRow[props.column.field] }}
                      </div>
                    </div>
                  </template>
                </vue-good-table>
                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </template>
        <template v-else>
          <app-component-barcode :selected="selectedRows"></app-component-barcode>
        </template>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import Vue from "vue";
import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
  name: "ComponentInventoryList",
  components: {

    appComponentBarcode: () => import('@/components/ComponentBarcode'),


  },
  metaInfo() {
    return {title: "PDC Stock | " + process.env.COPYRIGHT_NAME}
  },
  mixins: [commonMixins, dataTableMixins],
  data: () => ({
    hideButton: false,
    pageTitle: "PDC Stock",
    firstLoad: 0,
    permissions: [],
    cantAccessPage: "",
    userColumns: [],
    velocity_env: process.env.NODE_ENV,
    columns: [
      {
        label: 'Part #',
        field: 'vendor_item_number',
        filterable: true,
        hidden: false,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Part number", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Part Desc',
        field: 'name',
        filterable: true,
        hidden: false,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Part Desc", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Order multiple',
        field: 'order_multiplier',
        filterable: true,
        hidden: false,
        fpFieldType: "integer",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Vendor Part number", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Quantity',
        field: 'quantity',
        filterable: true,
        fpFieldType: "integer",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Quantity", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Dealer Cost',
        field: 'base_price',
        filterable: true,
        fpFieldType: "integer",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Dealer Cost", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Warranty Reimbursement Price',
        field: 'warranty_price',
        filterable: true,
        fpFieldType: "integer",
        hidden: false,
        sortable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Warranty Reimbursement Price", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
    ],
    rows: [],
    totalRecords: 0,
    loading: false,
    action: "list",
    showBarcode: false,
    pageKey: "_item_list_",
    batchProcess: 0,
    batchNum: "",
    duplicatePart: [],
    importedCount: 0,
    import_error: '',
    fileName: '',
    canViewInventory: false
  }),
  watch: {

    //check permission change
    permissions: function (permissions) {

      var self = this;
      if (permissions.length > 0) {
        for (let permission of permissions) {
          if (self.velocity_env === "velev" || self.velocity_env === "velev_test") {
            if (permission.name === 'ev_list_inventory') {
              self.cantAccessPage = true;
            }
            if (permission.name === 'ev_view_inventory') {
              self.canViewInventory = true;
              for (const element of this.columns) {
                if (element.field === 'action') {
                  this.$set(element, 'hidden', false)
                }
              }
            }
          } else {
            if (permission.name === 'list_component_transaction') {
              self.cantAccessPage = true;
            }
          }
        }
      }

    }
  },
  created: function () {

  },
  mounted: function () {
    var self = this;
    self.getPermissions();
  },
  methods: {
    cancelAll: function (cancelAll) {
      this.$refs.listComponentInventoryTable.unselectAllInternal();
    },

    backBtn() {

      this.showBarcode = false;

    },


    selectionChanged(param) {

      var self = this;
      self.serverParams.selectedAll = false;
      if (param.selectedRows.length == 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
      return;
    },
    exportCheck: function () {
      var self = this;
      var count = 0;
      var actionFlag = "";
      var data = this.$refs['listComponentInventoryTable'].selectedRows;
      count = data.length;

      if (this.serverParams.selectedAll == true) {
        actionFlag = "";
      } else if (count != 0 && count <= 100) {
        actionFlag = "export";
      }

      this.exportReports(actionFlag);
    },
    transferItem: function () {
      var self = this;

      self.$router.push('/inventory-transfer/list');
    },


    loadList() {

      var self = this;
      self.loading = true;
      //get selected customers ids

      var selectedRows = [];

      if (self.firstLoad == 1) {
        //because on first load list not initialize
        var data = this.$refs['listComponentInventoryTable'].selectedRows;
        for (var i = 0; i < data.length; i++) {
          selectedRows.push(this.$refs['listComponentInventoryTable'].selectedRows[i].id)
        }
      }

      var path = window.location.pathname;
      var segments = path.split("/");
      if (segments[2] == 'listrsb') {
        var id = segments[3];
      } else {
        var id = 0;
      }
      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters,
        sort: self.serverParams.sort,
        flag: self.flag,
        selectedRows: selectedRows,
        action: self.action,
        selectedAll: self.serverParams.selectedAll,
        id: id
      };
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/item/list",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status == "success") {

            if (self.action == "delete") {

              self.action = "list";
              self.$refs.filterComponentInventory.clearSelectAll();
              self.loadList();

            } else if (self.action == "export" || self.action == "export_queue") {

              if (data.code == "201") {
                alert(data.message);
              } else {
                if (self.action == "export") {
                  self.excel = data.content;
                  var save = document.createElement("a");
                  save.href = self.excel;
                  save.download = data.content;
                  save.target = "_blank";

                  document.body.appendChild(save);
                  save.click();
                  document.body.removeChild(save);

                } else {

                  self.batchProcess = 1;
                  self.batchNum = data.content;
                }
              }
              self.action = "list";

            } else {

              self.rows = data.content.row;
              self.totalRecords = data.content.totalRecords;
              self.filteredFlag = false;

            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'component-list')
        }
      });
    },

    generateExcelSample() {
      let self = this;
      self.loading = true;
      $.ajax({
        url:
          process.env.ROOT_API + "/component-inventory-excel/generate",
        type: "POST",
        crossDomain: true,
        dataType: "json",
        headers: this.ajxHeaders,
        success: function (data) {
          self.loading = false;

          let docPath = data.content.web;
          let save = document.createElement('a');
          save.href = docPath;
          save.download = docPath;
          save.target = '_blank';
          document.body.appendChild(save);
          save.click();
          document.body.removeChild(save);
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, 'ifta-upload-generate')

        }
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ComponentInventoryList.vue